import React, { useContext, useEffect, useRef, useState } from "react";
import { FaArrowLeft, FaCheckCircle, FaSearch, FaTrash } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import buildLink from "../../urls";
import axios from "axios";
import { CompanyContext } from "../../contexts/companyCotext";
import { IoIosWarning } from "react-icons/io";
import Loader from "../../components/loader";
import MessageAlert from "../../components/messageAlert";
import { PlaySounds } from "../../functions/playSounds";
import hocStarredPage from "../../components/hocStarredPage";
import Cookies from "js-cookie";

const ChangeUpcQuantity = () => {

  const {playErrorSound,playSuccessSound} = PlaySounds();
  const history = useNavigate();
  const codePr = useRef(null);
  const currentUpc = useRef(null);
  const restockQty = useRef(null);
  const [stateCom, dispatchCom] = useContext(CompanyContext);
  const commentRef = useRef(null);
  const [loading, setLoading] = useState(false);
  const [loadingSearch, setLoadingSearch] = useState(false);
  const [productInf, setProductInf] = useState(null);
  const [showMessgErr, setShowMessageErr] = useState(false);
  const [message, setMessage] = useState("");
  const [showMessgSucc, setShowMessageSucc] = useState(false);

  const searchProduct = async (e) => {
    e.preventDefault();
    setLoadingSearch(true);
    const item = codePr.current.value;

    try {
      const url = buildLink("productInfo") + `&item=${item}`+ `&user_id=${stateCom.userID}`;
      await axios.get(url).then((response) => {
        if (response.data.success) {
          restockQty.current.focus()
          setProductInf(response.data.data);
          currentUpc.current.value = response.data.data.upc;
        }
      });
      setLoadingSearch(false);
    } catch (e) {
      playErrorSound()
      setLoadingSearch(false);
      setMessage(e.response.data.message);
      setShowMessageErr(true);
      setTimeout(() => {
        setShowMessageErr(false);
      }, 3000);
    }
  };

  useEffect(() => {
    codePr.current.focus();
  }, []);

  const handleTrashClick = () => {
    codePr.current.value = "";
    codePr.current.focus();
  };


  const getUserIdFromLocalStorage = () => {
    return localStorage.getItem("userID");
  };


  async function restockUpc(e) {
    e.preventDefault()
    const userID = getUserIdFromLocalStorage()
    setLoading(true);
    const product_id = codePr.current.value;
    const upc_id = currentUpc.current.value;
    const user_id = userID;
    const restock_quantity = restockQty.current.value;
    const comment = commentRef.current.value;

    const obj = JSON.stringify({
      product_id,
      upc_id,
      user_id,
      restock_quantity,
      comment,
    });
    try {
      await axios
        .post(buildLink("changeUpcQuantity"), JSON.parse(obj))
        .then((response) => {
          if (response.data.success) {
            playSuccessSound()
            setMessage(response.data.message);
            setShowMessageSucc(true);
            setTimeout(() => {
              setShowMessageSucc(false);
            }, 3000);
          }
        });
    } catch (e) {
      playErrorSound()
      setMessage(e.response.data.message);
      setShowMessageErr(true);
      setTimeout(() => {
        setShowMessageErr(false);
      }, 3000);
    }
    setLoading(false);
  }

  return (
    <>
      <div className=" h-full bg-white">
        {/* header */}
        <div className=" mb-5 sticky top-0 flex flex-col bg-white ">
          <div className=" w-full bg-dbase h-16">
            <div className=" container flex relative gap-7 flex-row justify-start w-full text-white  h-full my-auto">
              <button onClick={() => history(-1)}>
                <FaArrowLeft />
              </button>
              <h2 className=" text-xl    my-auto">Change Upc Quantity</h2>
            </div>
          </div>
        </div>
        <div className="container flex flex-col gap-5">
          <form onSubmit={(e) => searchProduct(e)}>
            <div className=" flex flex-row justify-center gap-3 ">
              <div className="relative flex-1">
                <input
                  ref={codePr}
                  type="text"
                  className="border border-dlabelColor outline-dbase w-full rounded-md  py-3 pr-8  pl-2"
                  placeholder="Product ID Or Sku"
                />
                <div>
                  <FaTrash
                    onClick={() => handleTrashClick()}
                    className="absolute top-1/2 transform -translate-y-1/2 right-3 cursor-pointer opacity-20 "
                  />
                </div>
              </div>
              <button className=" bg-dbase rounded-md text-white px-5 ">
                {loadingSearch ? <Loader /> : <FaSearch />}{" "}
              </button>
            </div>
          </form>
            <form onSubmit={(e)=>restockUpc(e)} className=" flex flex-col gap-5"> 
          <div className="relative flex-1">
            <input
              ref={currentUpc}
              type="text"
              className="border border-dlabelColor outline-dbase w-full rounded-md  py-3 pr-8  pl-2"
              placeholder="Current UPC"
            />
          </div>

          <div className="relative flex-1">
            <input
            required
              ref={restockQty}
              type="text"
              className="border border-dlabelColor outline-dbase w-full rounded-md  py-3 pr-8  pl-2"
              placeholder="Change Quantity"
            />
          </div>

          <div className="relative flex-1">
            <input
              ref={commentRef}
              type="text"
              className="border border-dlabelColor outline-dbase w-full rounded-md  py-3 pr-8  pl-2"
              placeholder="Comment"
            />
          </div>

          <button
          
            type="submit"
            className=" bg-dbase  px-3 py-3 text-white rounded-sm mt-3"
          >
            {" "}
            {loading ? "Loading..." : "Confirm Restock"}
          </button>
          </form>
        </div>

        {productInf && (
          <div className="container">
            <div className="bg-white rounded-md shadow-md w-full px3 py-2 mt-10 ">
              <div className=" flex flex-row gap-5">
                <img src={productInf.image} alt="" />
                <div className=" my-auto">
                  <div className=" flex flex-col justify-center">
                    <h2>SKU: {productInf.sku}</h2>
                    <h2>Qty: {productInf.quantity}</h2>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
        <MessageAlert
          message={message}
          type={showMessgErr ? "err" : "succ"}
          showMessg={showMessgErr || (showMessgSucc && true)}
        />
      </div>
    </>
  );
};

export default hocStarredPage(ChangeUpcQuantity);
